var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { transient, autoinject } from "aurelia-dependency-injection";
import { CacheClient } from "../../../../services/basics/client-caching.service";
import { RequestClient } from "../../../../services/basics/request-client.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { NavigationClientService } from "../../../../services/modules/navigation-client.service";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { IFramePostMessages } from "../../../../models/modules/lotteryplatform-client.models";
import { MobileHelper } from "../../../../helpers/mobile-helper";
import { clientComponentModuleId } from "../../../../styles/client/render-engine/render-engine.helper";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { InstantGameKeyHelper } from "../../../../services/modules/brand-client.service";
import { toNative } from "../../../../utilities/promise-utils";
var LoginDialog = /** @class */ (function () {
    function LoginDialog(cacheClient, requestClient, notificationClientService, i18n, router, navigationClient, tokenClient, dialogClientService) {
        var _this = this;
        this.cacheClient = cacheClient;
        this.requestClient = requestClient;
        this.notificationClientService = notificationClientService;
        this.i18n = i18n;
        this.router = router;
        this.navigationClient = navigationClient;
        this.tokenClient = tokenClient;
        this.dialogClientService = dialogClientService;
        this.func = function (x) {
            if (x && x.data && x.data.event == IFramePostMessages.reloadPage) {
                localStorage.setItem(IFramePostMessages.reloadPage, JSON.stringify(_this.model));
                var router = _this.router;
                localStorage.setItem("".concat(IFramePostMessages.reloadPage, "-previous-route"), JSON.stringify({
                    routeName: router.currentInstruction.config.name,
                    params: router.currentInstruction.params
                }));
                var parentUrl = document.referrer;
                window.parent.location = parentUrl;
            }
        };
    }
    LoginDialog.prototype.activate = function (model) {
        this.model = model;
        var parentUrl = this.tokenClient.referer ? this.tokenClient.referer : document.referrer;
        var current = location.href;
        var arr = parentUrl.split("/");
        var arrCurrent = current.split("/");
        this.page = arrCurrent[0] + "//" + arr[2] + "/account/LotteryPlatformLogin";
    };
    LoginDialog.prototype.attached = function () {
        window.addEventListener('message', this.func, true);
    };
    LoginDialog.prototype.getInstantGameKey = function (name) {
        var key = name ? InstantGameKeyHelper.getKey(name) : '';
        return key;
    };
    LoginDialog.prototype.processMessage = function (router) {
        return __awaiter(this, void 0, void 0, function () {
            var request, instantGame, key_1, method, message, e_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 16, , 18]);
                        request = JSON.parse(localStorage.getItem(IFramePostMessages.reloadPage));
                        console.log("Request :" + this.tokenClient.isAgent());
                        if (!request) return [3 /*break*/, 13];
                        localStorage.removeItem(IFramePostMessages.reloadPage);
                        if (request.action == "openDialog") {
                            instantGame = request.instantGame;
                            key_1 = this.getInstantGameKey(instantGame.instantGameName);
                            setTimeout(function () {
                                _this.dialogClientService.show(clientComponentModuleId("dialogs/instant-game-dialog"), {
                                    instantGameId: instantGame.instantGameId,
                                    key: key_1,
                                    brandInstantGameId: instantGame.brandInstantGameId,
                                    transactionId: request.transactionId
                                }, false, false, MobileHelper.isMobileDevice());
                            }, 1000);
                            window.dataLayer.push({
                                "openedInstantGameId": instantGame.instantGameId,
                                "openedInstantGameName": instantGame.instantGameName,
                                "event": "navigate_instant_game"
                            });
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, , 12]);
                        if (!this.tokenClient.isAgent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.navigateToPreviousRoute(router)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 3:
                        method = request.method.toLowerCase();
                        if (!(method == "get")) return [3 /*break*/, 5];
                        return [4 /*yield*/, toNative(this.requestClient.get(request.url, request.params))];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        if (!(method == "post")) return [3 /*break*/, 7];
                        return [4 /*yield*/, toNative(this.requestClient.post(request.url, request.params, request.data))];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        message = request.url && request.url.toLowerCase().indexOf("instantgame") != -1 ?
                            this.i18n.tr("action-completed-description-instant-games") : this.i18n.tr("action-completed-description");
                        return [4 /*yield*/, this.navigateToPreviousRoute(router, this.i18n.tr("action-completed"), message, NotificationType.Success)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_1 = _b.sent();
                        return [4 /*yield*/, this.navigateToPreviousRoute(router, this.i18n.tr("action-failed"), this.i18n.tr(e_1.response), NotificationType.Error)];
                    case 11:
                        _b.sent();
                        return [3 /*break*/, 12];
                    case 12: return [3 /*break*/, 15];
                    case 13: return [4 /*yield*/, this.navigateToPreviousRoute(router)];
                    case 14:
                        _b.sent();
                        _b.label = 15;
                    case 15: return [3 /*break*/, 18];
                    case 16:
                        _a = _b.sent();
                        return [4 /*yield*/, this.navigateToPreviousRoute(router)];
                    case 17:
                        _b.sent();
                        return [3 /*break*/, 18];
                    case 18: return [2 /*return*/];
                }
            });
        });
    };
    LoginDialog.prototype.navigateToPreviousRoute = function (router, notificationTitle, notificationDescription, notificationType) {
        if (notificationTitle === void 0) { notificationTitle = null; }
        if (notificationDescription === void 0) { notificationDescription = null; }
        if (notificationType === void 0) { notificationType = null; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (notificationType && notificationTitle)
                    this.notificationClientService.show(notificationTitle, notificationDescription, notificationType);
                return [2 /*return*/];
            });
        });
    };
    LoginDialog.prototype.detached = function () {
        window.removeEventListener('message', this.func);
    };
    LoginDialog = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [CacheClient, RequestClient, NotificationClientService,
            I18N, Router, NavigationClientService, TokenClient, DialogClientService])
    ], LoginDialog);
    return LoginDialog;
}());
export { LoginDialog };
